
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_549_1118)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 4a3 3 0 00-3 3v10a3 3 0 003 3h16a3 3 0 003-3V7a3 3 0 00-3-3H4zM3 7.267V17a1 1 0 001 1h16a1 1 0 001-1V7.267l-7.158 5.567a3 3 0 01-3.684 0L3 7.267zM19.371 6H4.63l6.757 5.256a1 1 0 001.228 0L19.371 6z","fill":"#313131"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_549_1118"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      